<template>
  <div class="app-main-inner">
    <div style="width: fit-content">
      <div class="section">
        <el-form :disabled="readonly" :inline="true" label-position="left" label-width="75px">
          <el-form-item :label="$t('SeaExport.BusinessNo')">
            <el-input v-model="job.jobNo" :disabled="true" no="jobNo" class="job-no-color" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerReferenceNumber')">
            <cargo-input v-model="job.customerRefNo" no="customerRefNo" :auto-uppercase="true" :trim="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
            <cargo-input v-model="job.poNo" no="poNo" :auto-uppercase="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateCreated')">
            <el-input v-model="today" no="today" :disabled="true" />
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex">
        <el-form
          :disabled="readonly"
          label-position="right"
          label-width="100px"
          style="display: flex;"
        >
          <div class="section form-column">
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  clearable
                  :data-filter-function="p => p.statusEnabled && p.airImportEnabled"
                  :default-value="job.saleProductCode || ''"
                  @parentCallBack="p => {job.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  clearable
                  :default-value="job.fullOrInside || ''"
                  @parentCallBack="p => {job.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <cargo-advance-select
                no="solicitationType"
                filterable
                :select-type="selectTypeNames.local_cache_CargoSource"
                callback-method-type="value"
                :default-value="job.cargoSource"
                :callback-params="{key:'cargoSource'}"
                :clearable="false"
                @parentCallBack="cargoSource_Change"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                no="customJobType"
                filterable
                :select-type="selectTypeNames.basic_data_CutomJobType"
                :method-params="{type:job.lob, active:true}"
                callback-method-type="value"
                :default-value="job.customJobType"
                :callback-params="{key:'customJobType'}"
                :placeholder="$t('Message.PleaseSelect')"
                @parentCallBack="onCustomJobTypeChange"
              />
            </el-form-item>
            <div v-show="job.cargoSource==='NC'">
              <el-form-item :label="$t('SeaExport.NominatedAgent')">
                <cargo-company-select
                  no="designationAgentNominated"
                  :method-params="{overseaAgent:true,active:true}"
                  :default-value="job.designationAgent||''"
                  tag-name="englishName"
                  @change="designationAgentChangeHandler"
                />
              </el-form-item>
              <el-form-item :label="$t('SeaExport.PortOfLoadingAgent')">
                <cargo-company-select
                  no="loadingAgentId"
                  :method-params="{overseaAgent:true,active:true}"
                  :default-value="job.loadingAgentId||''"
                  tag-name="englishName"
                  @change="loadingAgentChangeHandler"
                />
              </el-form-item>
            </div>
            <el-form-item
              :label="job.cargoSource==='NC'?$t('SeaExport.ActualNotifyParty'):$t('SeaExport.ConsignationCompany')"
            >
              <cargo-sales-company-select
                no="customerId"
                :method-params="{customer:true,active:true}"
                :default-value="job.customerId||''"
                :placeholder="$t('SeaExport.RequiredItem')"
                style="width: 180px;"
                @parentCallBack="txtCustomerId_changeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ContactPerson')">
              <el-select v-model="job.customerContact" no="customerContact" filterable>
                <el-option
                  v-for="(item,index) in contactList"
                  :key="index"
                  :label="item.contactPerson"
                  :value="item.contactPerson"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Tel')">
              <el-input v-model="job.contactTelephone" no="contactTelephone" />
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Fax')">
              <el-input v-model="job.contactFax" no="contactFax" />
            </el-form-item>
            <el-form-item
              v-show="job.cargoSource!=='NC'"
              :label="$t('SeaExport.PortOfLoadingAgent')"
            >
              <cargo-company-select
                no="portOfLoadingAgent"
                :method-params="{overseaAgent:true,active:true}"
                :default-value="job.loadingAgentId||''"
                tag-name="englishName"
                @change="loadingAgentChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineCompany')">
              <cargo-advance-select
                no="carrierId"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{airCmp:true,active:true}"
                :callback-params="{key:'carrierId'}"
                tag-name="chineseName"
                :default-value="job.carrierId || ''"
                @parentCallBack="txtCarrierId_changeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FlightNo')">
              <cargo-input v-model="job.voyageFlight" no="voyageFlight" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBillNo')">
              <el-tooltip
                :content="(job.express||mblCodeNumValidate)?'':$t('queryJob.TheDoesNotComplyRules')"
                placement="right-end"
              >
                <div style="display: flex">
                  <el-checkbox v-model="job.express">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
                  <cargo-input
                    v-show="job.express"
                    v-model="job.mbl"
                    no="mblExpress"
                    :maxlength="32"
                    :auto-uppercase="true"
                    style="margin-left: 2px;"
                  />
                  <el-input
                    v-show="!job.express"
                    :value="mblCode"
                    no="mblCode"
                    maxlength="3"
                    :class="mblCodeNumValidate?'':'red'"
                    style="width: 80px;margin-left: 2px;"
                    @input="onMblCodeInput"
                    @blur="onMblCodeNumBlur"
                  />
                  <span v-show="!job.express" style="padding-right: 2px;padding-left: 1.5px;">-</span>
                  <cargo-input
                    v-show="!job.express"
                    ref="mblNum"
                    v-model="mblNum"
                    no="mblNum"
                    :maxlength="8"
                    :input-convert="filterNonDigit"
                    :class="mblCodeNumValidate?'':'red'"
                    style="width: 150px;"
                    @blur="onMblCodeNumBlur"
                  />
                </div>
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Hbl2')">
              <cargo-input v-model="job.hbl" no="hbl" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceipt')">
              <cargo-input v-model="job.dispatchingPlace" no="dispatchingPlaceAir" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.LoadingPort')">
              <cargo-advance-select
                no="loadingPortCodeAir"
                filterable
                :select-type="selectTypeNames.basic_data_Airport"
                callback-method-type="value"
                :default-value="job.loadingPortCode"
                :callback-params="{key:'loadingPortCode'}"
                :placeholder="$t('SeaExport.RequiredItem')"
                style="flex:1"
                @parentCallBack="loadingPortCodeChange"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfDestination')">
              <cargo-advance-select
                no="dischargingPortCode"
                filterable
                :select-type="selectTypeNames.basic_data_Airport"
                :default-value="job.dischargingPortCode"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="dischargingPortCode_Change"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FinalPlaceOfDelivery')">
              <cargo-input v-model="job.destinationPlace" no="destinationPlace" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationWay')">
              <cargo-advance-select
                no="customClaim"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.local_cache_AirExportConstants$CUSTOM_CLAIMS"
                :default-value="job.customClaim===-1?'':job.customClaim"
                :tag-name="isZh?'chineseName':'englishName'"
                tag-value="code"
                :zero-can-copy="true"
                :fields="[isZh?'chineseName':'englishName']"
                @parentCallBack="p=>{job.customClaim=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="job.customClaim===1" :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="job.customsDeclarationType===-1?'':job.customsDeclarationType"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{job.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.TerminalAddress')">
              <cargo-rich-textarea
                v-model="job.deliveryAddress"
                no="deliveryAddress"
                :disabled="readonly"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('Message.TerminalAddress'),job.deliveryAddress, undefined, val=>{job.deliveryAddress=val})"
              />
            </el-form-item>
          </div>
          <div class="section form-column" :style="$selectByLang('', 'width: 350px')">
            <el-form-item :label="$t('SeaExport.DateOfDeparture')">
              <el-date-picker
                v-model="job.etd"
                no="etd"
                type="datetime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                clearable
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ExpectedArrivalDate')">
              <el-date-picker
                v-model="job.eta"
                no="eta"
                type="datetime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                clearable
                :placeholder="$t('SeaExport.RequiredItem')"
              />
            </el-form-item>
            <el-form-item label>
              <div style="display: flex;justify-content: flex-end">
                <el-button
                  type="primary"
                  no="copyFromOtherBill"
                  @click="importPromptTitleDialog.visible=true"
                >{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
                <el-button
                  type="primary"
                  no="codeSearching"
                  @click="billAddressDialog.visible=true"
                >{{ $t('SeaExport.CodeSearching') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Shipper')">
              <div style="display: flex;justify-content: space-between;">
                <cargo-input
                  v-model="job.shipperCode"
                  no="shipperCode"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :placeholder="$t('Tool.Code')"
                  style="width: 70px;margin-right: 5px;"
                />
                <cargo-input
                  v-model="job.shipperLine1"
                  no="shipperLine1"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
                  style="flex: 1"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),undefined,splitShipperLine)"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Consignee')">
              <div style="display: flex;justify-content: space-between;">
                <cargo-input
                  v-model="job.consigneeCode"
                  no="consigneeCode"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :placeholder="$t('Tool.Code')"
                  style="width: 70px;margin-right: 5px;"
                />
                <cargo-input
                  v-model="job.consigneeLine1"
                  no="consigneeLine1"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
                  style="flex: 1"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),undefined,splitConsigneeLine)"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NotifyParty')">
              <div style="display: flex;justify-content: space-between;">
                <cargo-input
                  v-model="job.notifyCode"
                  no="notifyCode"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :placeholder="$t('Tool.Code')"
                  style="width: 70px;margin-right: 5px;"
                />
                <cargo-input
                  v-model="job.notifyLine1"
                  no="notifyLine1"
                  :auto-uppercase="notUppercaseShipperConsigneNotify"
                  :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
                  style="flex: 1"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),undefined,splitNotifyLine)"
                />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualQuantity')">
              <auto-number-input
                v-model="job.quantityActual"
                no="quantityContract"
                :precision="0"
                :min="0"
                @change="quantityContractCharge"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')">
              <!-- <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Packing"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.packing+''"
                tag-name="chineseName"
                :callback-params="{key:'packing'}"
                @parentCallBack="setJobSelectValue"
              /> -->
              <cargo-packing-select
                no="packing"
                :default-value="job.packing"
                @change="p => {p.key = 'packing';setJobSelectValue(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualWeight')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.weightActual"
                  no="weightContract"
                  :precision="3"
                  :min="0"
                  @change="calculateChargeWeight"
                />
                <div style="width: 40px;font-size: 12px;font-weight: normal;color: #404144">
                  <span>KGS</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualVolume')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.cubageActual"
                  no="cubageContract"
                  :precision="3"
                  :min="0"
                  @change="calculateChargeWeight"
                />
                <div style="width: 40px; font-size: 12px;font-weight: normal;color: #404144">
                  <span>CBM</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeight')">
              <auto-number-input
                v-model="job.chargeWeight"
                no="chargeWeight"
                :precision="3"
                :min="0"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ChineseCargoName')">
              <cargo-input
                v-model="job.cargoChineseName"
                no="cargoChineseName"
                type="textarea"
                :rows="3"
                :auto-uppercase="true"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,0,val=>{job.cargoChineseName=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_EnglishCargoName')">
              <cargo-input
                v-model="job.cargoEnglishName"
                no="cargoEnglishName"
                type="textarea"
                :rows="3"
                :auto-uppercase="isUppercaseByConfig"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,0,val=>{job.cargoEnglishName=val},isUppercaseByConfig)"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms')">
              <cargo-advance-select
                no="incoTermData"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.incoTerm+''"
                :callback-params="{key:'incoTerm'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <cargo-input
                v-model="job.remarks"
                no="remarks"
                type="textarea"
                :rows="3"
                :auto-uppercase="true"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.remarks,0,val=>{job.remarks=val})"
              />
            </el-form-item>
          </div>
          <div class="section form-column">
            <el-form-item :label="$t('SeaExport.OperateType')">
              <cargo-advance-select
                no="operateType"
                filterable
                :select-type="selectTypeNames.local_cache_ImportConstants$_cargoTypeAirInputList"
                callback-method-type="value"
                :default-value="job.operateType"
                :callback-params="{key:'operateType'}"
                :clearable="false"
                @parentCallBack="onOperateTypeChange"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <cargo-advance-select
                no="cargoType"
                filterable
                :select-type="selectTypeNames.basic_data_CargoType"
                :method-params="{air:true}"
                callback-method-type="value"
                :default-value="job.cargoType"
                :callback-params="{key:'cargoType'}"
                :clearable="false"
                @parentCallBack="onCargoTypeChagne"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HBLFreightClause')">
              <cargo-advance-select
                no="paymentTermHBL"
                filterable
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                callback-method-type="value"
                :default-value="job.paymentTermHBL"
                :callback-params="{key:'paymentTermHBL'}"
                :clearable="false"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                no="paymentTermMBL"
                filterable
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                callback-method-type="value"
                :default-value="job.paymentTermMBL"
                :callback-params="{key:'paymentTermMBL'}"
                :clearable="false"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="incoTerm"
                filterable
                :select-type="selectTypeNames.basic_data_IncoTerm"
                callback-method-type="value"
                :default-value="job.incoTerm"
                :callback-params="{key:'incoTerm'}"
                :clearable="false"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="tradeTerm"
                filterable
                :select-type="selectTypeNames.basic_data_TradeTerm"
                callback-method-type="value"
                :default-value="job.tradeTerm"
                :callback-params="{key:'tradeTerm'}"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirportHandlingAgent')">
              <cargo-advance-select
                no="groundAgentId"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true,active:true}"
                :callback-params="{key:'groundAgentId'}"
                callback-method-type="value"
                :default-value="job.groundAgentId||''"
                placeholder=" "
                @parentCallBack="setJobSelectNum"
              />
            </el-form-item>
          </div>
          <div class="section form-column">
            <el-form-item :label="$t('SeaExport.SalesCompany')">
              <el-input v-model="txtSalesOffice" :disabled="true" no="txtSalesOffice" :placeholder="$t('SeaExport.RequiredItem')" />
            </el-form-item>
            <el-form-item>
              <span slot="label" :class="job.cargoSource!=='NC'?'blue':''">{{ $t('SeaExport.Sales') }}</span>
              <div style="display: flex;justify-content: space-between">
                <cargo-user-select
                  ref="sales"
                  no="sales"
                  :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                  :default-value="job.sales||''"
                  :static-options="salesList"
                  style="flex: 1"
                  placeholder=" "
                  @change="salesChangeHandler"
                />
                <el-checkbox
                  v-model="job.provisioned"
                  no="provisioned"
                  :disabled="true"
                  style="margin-left: 5px;margin-right: 0px;"
                >{{ $t('SeaExport.Accrued') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="cargoSalesId"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                placeholder=" "
                :static-options="cargoSalesList"
                @change="cargoSalesChargeHandler"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" :class="job.cargoSource==='SC'?'blue':''">{{ $t('SeaExport.SalesDepartment') }}</span>
              <cargo-department-new-select
                :disabled="!job.sales"
                no="salesOffice"
                :sales-id="Number(job.sales)"
                :enables="true"
                :office-id="job.salesOffice"
                :department-id="Number(job.salesDepartment)"
                placeholder=" "
                @change="departmentChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-advance-select
                no="opOffice"
                :disabled="opOfficeDisabled"
                :select-type="selectTypeNames.basic_data_Office"
                filterable
                :static-options="cacheOffices"
                :callback-params="{key:'opOffice'}"
                callback-method-type="value"
                :default-value="job.opOffice||''"
                placeholder=" "
                @parentCallBack="p=>{setJobSelectNum(p);job.opDepartment=0;opOfficeChargeHandler()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_OperationDepartment') }}</span>
              <cargo-department-select
                no="opDepartment"
                :office-id="Number(job.opOffice)"
                :enables="true"
                :department-id="Number(job.opDepartment)"
                placeholder=" "
                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(job.csrOffice)"
                @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(job.csrOffice)"
                :enables="true"
                :department-id="Number(job.csrDepartment)"
                @change="p=>{job.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                no="csr"
                :method-params="{category:'role',shape:'csr'}"
                :default-value="job.csr||''"
                placeholder=" "
                :static-options="userPortRoleData.csr"
                @change="csrChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Operation')">
              <cargo-user-select no="operation" :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOffice.code==='HB'?'':$store.getters.currentOfficeId}" :default-value="job.op||''" placeholder=" " :static-options="userPortRoleData.op" @change="opChangeHandler" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(job.dcOffice)"
                @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(job.dcOffice)"
                :enables="true"
                :department-id="Number(job.dcDepartment)"
                @change="p=>{job.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select no="dc" :method-params="{category:'role',shape:'doc'}" :default-value="job.dc||''" placeholder=" " :static-options="userPortRoleData.doc" @change="dcChangeHandler" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(job.plannerOffice)"
                @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :office-id="Number(job.plannerOffice)"
                :enables="true"
                :department-id="Number(job.plannerDepartment)"
                @change="p=>{job.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AirlinePerson')">
              <cargo-user-select
                no="planner"
                :method-params="{category:'role',shape:'airline'}"
                :default-value="job.planner||''"
                placeholder=" "
                :static-options="userPortRoleData.airline"
                @change="plannerChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PolOperation')">
              <cargo-user-select
                no="loadingPortOp"
                :method-params="{category:'role',shape:'aiop'}"
                :default-value="job.loadingPortOp||''"
                placeholder=" "
                @change="p=>{job.loadingPortOp=p.value||0}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PodOperation')">
              <cargo-user-select
                no="destinationPortOp"
                :method-params="{category:'role',shape:'aiop'}"
                :default-value="job.destinationPortOp||''"
                placeholder=" "
                @change="p=>{job.destinationPortOp=p.value||0}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                no="siteOP"
                :method-params="{category:'role',shape:'siteOp'}"
                :default-value="job.siteOP||''"
                placeholder=" "
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                class="input2"
                placeholder=" "
                :default-value="job.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                :merge-load="true"
                @change="p=>{
                  job.overseaOp = p.value
                  OverseaCustomerUtils.overseaOpChangeHandler(view, p)
                }"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="job.taxNature"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </div>
        </el-form>
      </div>
      <!-- 单号抄录 -->
      <import-prompt-title-dialog
        :visible.sync="importPromptTitleDialog.visible"
        :lob="job.lob"
        @selected="onExcerptionChangeFunc"
      />
      <!-- 代码检索 -->
      <import-bill-address-title-dialog
        :visible.sync="billAddressDialog.visible"
        :job="job"
        @callback="codeSearchCallback"
      />
      <!-- 高级文本弹框 -->
      <el-dialog
        v-el-drag-dialog
        :visible.sync="advanceTextDialog.visible"
        :title="advanceTextDialog.title"
        width="665px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <cargo-rich-textarea
          v-model="advanceTextDialog.value"
          no="textChars"
          :disabled="readonly"
          :text-chars="advanceTextDialog.textChars"
          :auto-uppercase="advanceTextDialog.isUppercase"
          :warning-count="-1"
          style="height: 198px;"
        />
        <span slot="footer">
          <el-button
            v-show="isEdit"
            type="primary"
            @click="finishAdvanceText"
          >{{ $t('common.btn.confirm') }}</el-button>
          <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import tabBookingFCLJS from './tabBookingFCL.js'
import moment from 'moment'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import ImportPromptTitleDialog from '@/components/Cargo/Job/importPromptTitleDialog'
import ImportBillAddressTitleDialog from '@/components/Cargo/Job/importBillAddressTitleDialog'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import CargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { getBranchByLevel } from '@/utils/basicDataCache'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import { TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'AiOrderTabBookingFCL',
  components: {
    cargoOfficeSelect,
    cargoAdvanceSelect, cargoPackingSelect, cargoInput, cargoCompanySelect, cargoUserSelect, cargoDepartmentSelect, cargoDepartmentNewSelect, cargoRichTextarea, ImportPromptTitleDialog,
    ImportBillAddressTitleDialog, AutoNumberInput, CargoSalesCompanySelect
  },
  mixins: [BasicTabMixin],
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      isZh: this.$store.getters.language === 'zh',
      salesOfficeCheck: false,
      isHC: false,
      job: new AirImportJob().fillDefaultValue().getData(),
      today: moment().format('YYYY-MM-DD'),
      TAX_NATURES,
      contactList: [],
      mblCode: '',
      mblNum: '',
      mblCodeNumValidate: true,
      salesList: null,
      txtSalesOffice: '', // 销售所在分公司
      importPromptTitleDialog: {
        visible: false
      },
      billAddressDialog: {
        visible: false
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        textChars: undefined,
        successCallback: null,
        isUppercase: true
      },
      JobUtils,
      overseaAgentUsersList: [], // 海外客服用户列表
      OverseaCustomerUtils,
      view: this,
      poNoRed: false,
      needConfirmProjectNo: false,
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      cargoSalesList: null,
      isZY: false, // 显示中邮选项
      isShowContactPersonDetail: false, // 海创显示详细信息
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    cacheOffices() {
      if (this.isRegionalCommission) {
        return getBranchByLevel(this.job.opOffice)
      } else {
        return null
      }
    },
    // 销售分公司
    salesOffice() {
      return this.job.salesOffice
    }
  },
  async created() {
    // 扩展data
    Object.assign(this, {
      selectTypeNames: TYPE_NAMES
    })
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify(this.context.config)
    this.isUppercaseByConfig = await JobUtils.uppercaseCargoEnglishNameAndMark(this.context.config) // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
  },
  methods: tabBookingFCLJS.methods
}
</script>

<style scoped lang="scss">
#app .section ::v-deep {
  .job-no-color.el-input {
    .el-input__inner {
      background: #99ff66 !important;
    }
  }
  .red {
    .el-input__inner {
      color: #f56c6c !important;
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
